import { Injectable } from "@angular/core";
import { interval, throwError } from "rxjs";
import { RenovateService } from "./renovate.service";
import { concatMap } from "rxjs/operators";
import { Utils } from "../utils/utils";

type StorageStrategy = 'local' | 'session' | 'cookie';
type EnvironmentType = 'stg'| 'uat' | 'prod';

@Injectable({
  providedIn: "root",
})
export class TokenRefresh {

  constructor(
    private renovateService: RenovateService
  ) { }

  /**
  * @param minutesToRemove - Quantidade de minutos que irá ser removido do tempo total do Access Token.
  */
  public start(storageStrategy: StorageStrategy, env: EnvironmentType, minutesToRemove: number) {
    const accessToken = this._getAccessToken(storageStrategy);
    const decodedToken   = Utils.decodeToken(accessToken);
    const expireInTimestamp = (decodedToken?.exp) ? new Date(decodedToken.exp * 1000).getTime() : 0;
    const currentDateTimestamp = new Date().getTime();
    const leftTimestamp = expireInTimestamp - currentDateTimestamp;
    const timestampToMinutes = leftTimestamp / 1000 / 60;
    const calculatedInterval =
      Math.round(timestampToMinutes) - minutesToRemove;

    if (calculatedInterval >= 0) {
      return interval(calculatedInterval * 1000 * 60).pipe(
        concatMap(() => {
          return this.renovateService.renovateToken(); 
        })
      )
    }

    const err = new Error('O token está expirado'); 
    return throwError(() => err);
  }
  
  private _getAccessToken(storageStrategy: string): string {
    let token = '';

    switch (storageStrategy) {
      case 'cookie':
        token = Utils.getCookie('accessToken');
        break;
      case 'session':
        token = sessionStorage.getItem('accessToken') || '';
        break;
      default:
        token = localStorage.getItem('accessToken') || '';
        break;
    }

    return token;
  }
}
